<template>
    <div class="drag bor61a bradius25" ref="dragDiv">
        <div class="drag_bg bradius25"></div>
        <div class="drag_text">{{confirmWords}}</div>
                    <img class="imgauto handler" src="../../public/img/img159.png" alt=""  ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}">
    </div>
</template>

<script>
    export default {
        data() {
            return {
                beginClientX: 0,
                /*距离屏幕左端距离*/
                mouseMoveStata: false,
                /*触发拖动状态  判断*/
                maxwidth: '',
                /*拖动最大宽度，依据滑块宽度算出来的*/
                confirmWords: '',
                /*滑块文字*/
                confirmSuccess: false,
                /*验证成功判断*/
                pass: 0,
            }
        },
        methods: {
            mousedownFn: function(e) {
                if (!this.confirmSuccess) {
                    e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
                    this.mouseMoveStata = true;
                    this.beginClientX = e.clientX;
                }
            }, //mousedoen 事件
            successFunction() {
                this.confirmSuccess = true
                this.confirmWords = '验证通过';
                this.pass = 1;
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn);
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn);
                } else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => {});
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#fff';
                document.getElementsByClassName('drag')[0].style.background = '#7ac23c';
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth - 5 + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
                this.$emit('childFn', this.pass);
            }, //验证成功函数
            mouseMoveFn(e) {
                if (this.mouseMoveStata) {
                    let width = e.clientX - this.beginClientX;
                    if (width > 0 && width <= this.maxwidth) {
                        document.getElementsByClassName('handler')[0].style.left = width + 'px';
                        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
                    } else if (width > this.maxwidth) {
                        this.successFunction();
                    }
                }
            }, //mousemove事件
            moseUpFn(e) {
                this.mouseMoveStata = false;
                var width = e.clientX - this.beginClientX;
                if (width < this.maxwidth) {
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
                }
            } //mouseup事件
        },
        mounted() {
            this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
            document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn);
            document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn)
        }
    }
</script>

<style scoped>
    .drag {
        position: relative;
        background-color: #fff;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }
    
    .handler {
        width: 80px;
        height: 44px;
        cursor: move;
        position: absolute;
        top: 3px;
        left: 3px;
        bottom: 3px;
    }
    
    .drag_bg {
        /* background-color: #7ac23c; */
        height: 540px;
        width: 0px;
    }
    
    .drag_text {
        position: absolute;
        top: 0px;
        width: 100%;
        text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select: none;
        -ms-user-select: none;
    }
</style>